import api from '../configs/api.config';
import {
  ChargeAttemptStatistics,
  ChargeAttemptsList,
  ChargeAttemptsFilters,
  FailedInvoicesList,
  FailedInvoicesParams,
  StatisticsParams,
  ChargeAllOptions,
  ChargeableInvoicesResponse,
  ChargeableInvoicesParams,
  ResendDelinquentEmailsRequest,
  ResendDelinquentEmailsResponse
} from '../types/payment.types';
import { WEFResponse } from '../Types';

export const getChargeAttemptStatistics = async (
  params: StatisticsParams = {}
): Promise<ChargeAttemptStatistics> => {
  const { data } = await api.get<ChargeAttemptStatistics>('/Payment/charge-attempts/statistics', {
    params: {
      'months-back': params.monthsBack ?? 2,
      'group-by': params.groupBy ?? 'day'
    }
  });
  return data;
};

export const getChargeAttempts = async (
  filters: ChargeAttemptsFilters = {}
): Promise<ChargeAttemptsList> => {
  const params: Record<string, string | number | boolean> = {};

  if (filters.page) params['page'] = filters.page;
  if (filters.pageSize) params['page-size'] = filters.pageSize;
  if (filters.clientId) params['client-id'] = filters.clientId;
  if (filters.monitoringListId) params['monitoring-list-id'] = filters.monitoringListId;
  if (filters.amountMin !== undefined) params['amount-min'] = filters.amountMin;
  if (filters.amountMax !== undefined) params['amount-max'] = filters.amountMax;
  if (filters.success !== undefined) params['success'] = filters.success;
  if (filters.startDate) params['start-date'] = filters.startDate;
  if (filters.endDate) params['end-date'] = filters.endDate;
  if (filters.cardType) params['card-type'] = filters.cardType;
  if (filters.source) params['source'] = filters.source;

  const { data } = await api.get<ChargeAttemptsList>('/Payment/charge-attempts', { params });
  return data;
};

export const getFailedInvoices = async (
  params: FailedInvoicesParams = {}
): Promise<FailedInvoicesList> => {
  const { data } = await api.get<FailedInvoicesList>('/Payment/failed-invoices', {
    params: {
      'min-failed-attempts': params.minFailedAttempts ?? 3,
      page: params.page ?? 1,
      'page-size': params.pageSize ?? 20
    }
  });
  return data;
};

export const chargeAllInvoices = async (
  options: ChargeAllOptions
): Promise<WEFResponse<string>> => {
  const { data } = await api.post<WEFResponse<string>>('/Payment', options);
  return data;
};

export const stageInvoices = async (): Promise<void> => {
  await api.post('/Payment/stageInvoices');
};

export const getChargeableInvoices = async (
  params: ChargeableInvoicesParams = {}
): Promise<ChargeableInvoicesResponse> => {
  const { data } = await api.get<ChargeableInvoicesResponse>('/Payment/chargeable-invoices', {
    params: {
      'only-no-prior-attempts': params.onlyNoPriorAttempts ?? false
    }
  });
  return data;
};

export const resendDelinquentEmails = async (
  request: ResendDelinquentEmailsRequest
): Promise<ResendDelinquentEmailsResponse> => {
  const { data } = await api.post<ResendDelinquentEmailsResponse>(
    '/Payment/resend-delinquent-emails',
    request
  );
  return data;
};
